import * as React from 'react';
import { type HTMLProps } from 'react';
import * as _ from 'lodash';
// @ts-ignore
import { type Element } from 'hast';
import { safely } from '@epihub/core/src/fn/safely';
import { styled } from '../../theme/theme';
import { MessageTypeMarkdownFile } from './MessageTypeMarkdownFile';

type TMessageTypeMarkdownLinkProps = HTMLProps<HTMLAnchorElement> & {
  node: Element;
};

export const MessageTypeMarkdownLink = (props: TMessageTypeMarkdownLinkProps) => {
  const {
    className,
    node,
    ...otherProps
  } = props;

  const isDownload = safely(
    // @ts-ignore
    () => _.isString(props.children[0]) && `${props.children[0]}`.trim().startsWith('file:'),
    () => false,
  );

  return (
    <Root
      className={className}
    >
      {isDownload
        ? (
          <MessageTypeMarkdownFile
            {...props}
          />
        )
        : (
          // @ts-ignore
          <Link
            {...otherProps}
            className=''
            target='_blank'
          />
        )}
    </Root>
  );
};

const Root = styled.span`
`;

export const Link = styled.a`
  color: ${({ theme }: any) => theme.legacy.colors.accent2};
  font-weight: 500;
`;
